import _defineProperty from "/app/node_modules/.pnpm/next@13.4.17_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { memoize } from 'lodash';
import { logError, logMessage } from 'libs/utils/window';
export const logBrazeMessage = (message, extra) => logMessage(message, _objectSpread({
  feature: 'braze'
}, extra && {
  extra
}));
export const logBrazeError = (error, extra) => logError(error, _objectSpread({
  feature: 'braze'
}, extra && {
  extra
}));
/**
 * Will log a new `failureConfiguringSdk` error for each unique combination of failing parameters.
 */

export const logConfigurationFailure = memoize(options => {
  if (!options.isLoggedIn) return;

  const reason = (() => {
    if (!options.brazeSdkKey) return 'sdkKeyMissing';
    if (!options.userExternalId) return 'userExternalIdMissing';
    return 'unknown'; // in theory, should never happen
  })();

  logBrazeMessage('failureConfiguringSDK', "reason: ".concat(reason));
}, function () {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return JSON.stringify(args);
});

/**
 * Will log a new `missingContentError` error for each unique card and its property that is failing.
 */
export const logMissingContentError = memoize( // `_id` is unused, but required in the memoize's resolver, so we get a unique key
(_id, property, channel, campaignData) => {
  const channelMessage = channel ? ", channel: ".concat(channel) : '';
  logBrazeMessage("missingContentError(property: ".concat(property).concat(channelMessage, ")"), String(campaignData));
}, function () {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  return args.join(',');
});
/**
 * Will log a new `incorrectContentError` error for each unique card and its property that is failing.
 */

export const logIncorrectContentError = memoize( // `_id` is unused, but required in the memoize's resolver, so we get a unique key
(_id, property, channel, campaignData) => logBrazeMessage("incorrectContentError(property: ".concat(property, ", channel: ").concat(channel, ")"), String(campaignData)), function () {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  return args.join(',');
});
/**
 * Will log a new `contentParseError` error for each unique card that has faulty JSON
 */

export const logContentParseError = memoize( // `_id` is unused, but required in the memoize's resolver, so we get a unique key
(_id, channel, trackingData) => logBrazeMessage("contentParseError(channel: ".concat(channel, ")"), String(trackingData)), function () {
  for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    args[_key4] = arguments[_key4];
  }

  return args.join(',');
});
export const logSdkLoggingFailure = memoize( // `_id` is unused, but required in the memoize's resolver, so we get a unique key
(_id, type, channel, campaignData) => {
  logBrazeMessage("loggingFailure(type: ".concat(type, ", channel: ").concat(String(channel), ")"), String(campaignData));
}, function () {
  for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    args[_key5] = arguments[_key5];
  }

  return JSON.stringify(args);
});